import Header from "@/components/hotel/Header";
import Hero from "@/components/hotel/Hero";
import SkiBanner from "@/components/hotel/SkiBanner";
import HomeNews from "@/components/hotel/HomeNews";
import HomeAbout from "@/components/hotel/HomeAbout";
import GuestfriendBanner from "@/components/hotel/GuestfriendBanner";
import BadRagazSection from "@/components/hotel/BadRagazSection";
import HomeRooms from "@/components/hotel/HomeRooms";
import HomeApartments from "@/components/hotel/HomeApartments";
import HomeApartmentGallery from "@/components/hotel/HomeApartmentGallery";
import HomeDining from "@/components/hotel/HomeDining";
import Footer from "@/components/hotel/Footer";
import SEO from "@/components/SEO";
import { useLanguage } from "@/i18n/LanguageContext";

const Index = () => {
  const { t } = useLanguage();

  const faqJsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      { "@type": "Question", name: t.homeFAQ.q1, acceptedAnswer: { "@type": "Answer", text: t.homeFAQ.a1 } },
      { "@type": "Question", name: t.homeFAQ.q2, acceptedAnswer: { "@type": "Answer", text: t.homeFAQ.a2 } },
      { "@type": "Question", name: t.homeFAQ.q3, acceptedAnswer: { "@type": "Answer", text: t.homeFAQ.a3 } },
      { "@type": "Question", name: t.homeFAQ.q4, acceptedAnswer: { "@type": "Answer", text: t.homeFAQ.a4 } },
      { "@type": "Question", name: t.homeFAQ.q5, acceptedAnswer: { "@type": "Answer", text: t.homeFAQ.a5 } },
      { "@type": "Question", name: t.homeFAQ.q6, acceptedAnswer: { "@type": "Answer", text: t.homeFAQ.a6 } },
    ],
  };

  return (
    <main id="main-content" className="min-h-screen bg-background">
      <SEO
        title="ESOS Hotel Quelle | Boutique-Hotel Bad Ragaz"
        description="Willkommen im ESOS Hotel Quelle – Ihr charmantes Boutique-Hotel mit komfortablen Zimmern und Apartments im Herzen von Bad Ragaz, Schweiz."
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "Hotel",
            name: "ESOS Hotel Quelle",
            url: "https://esoshotelquelle.com",
            image: "https://storage.googleapis.com/gpt-engineer-file-uploads/LWmdENiduXdTolLj05Xw2KcFswk2/social-images/social-1774369533197-WhatsApp_Image_2026-03-24_at_15.26.52.webp",
            description: "Boutique-Hotel mit komfortablen Zimmern und Apartments in Bad Ragaz, Schweiz.",
            address: {
              "@type": "PostalAddress",
              streetAddress: "Badstrasse 9a",
              addressLocality: "Bad Ragaz",
              postalCode: "7310",
              addressRegion: "St. Gallen",
              addressCountry: "CH",
            },
            telephone: "+41 81 302 11 13",
            email: "reservation@esoshotelquelle.com",
            starRating: { "@type": "Rating", ratingValue: "3" },
            priceRange: "$$",
            checkinTime: "16:00",
            checkoutTime: "11:00",
          },
          faqJsonLd,
        ]}
      />
      <Header />
      <Hero />
      <SkiBanner />
      <HomeNews />
      <HomeAbout />
      <GuestfriendBanner />
      <div className="w-full h-4 md:h-6 bg-background" />
      <BadRagazSection />
      <HomeRooms />
      <HomeApartments />
      <HomeApartmentGallery />
      <HomeDining />
      <Footer />
    </main>
  );
};

export default Index;
